// languageSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resources } from "../../common/translations";

// Define the state type
interface LanguageState {
  currentLanguage: keyof typeof resources; // Only accept valid keys from resources
}

// Get the initial language from localStorage or default to "en"
const initialLanguage: keyof typeof resources = (localStorage.getItem("language") as keyof typeof resources) || "en";

const initialState: LanguageState = {
  currentLanguage: initialLanguage,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<keyof typeof resources>) => {
      state.currentLanguage = action.payload;
      localStorage.setItem("language", action.payload.toString()); // Save to localStorage
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
